import React, { useState } from 'react';
import { history } from 'ice';
import { Table, Link } from '@b-design/fusion';
import ColorTags from '@/components/ColorTags';
import { queryStringify } from '@/utils/url-parse';
import CreateMiniappDrawer from '@/components/CreateMiniappDrawer';
import { formatTime } from '@/utils';
import { getAppVersionStatus } from '@/utils/status';
import $i18n from '../../../../i18n';
import store from '@/store';

import './index.less';
import DefaultAppIcon from '@/components/DefaultAppIcon';

interface TableProps {
  dataSource: any[];
  loading: boolean;
  initFlag: any;
  spaceId: string;
  style?: React.CSSProperties;
  setCreateTitle: React.Dispatch<React.SetStateAction<string>>;
}

const changeRouter = (record, spaceId) => {
  history?.push(
    `/miniapp/detail?${queryStringify({
      spaceId,
      appId: record.appId,
    })}`,
  );
};

const actions = (_v, _i, record, spaceId) => {
  return (
    <div className="actions-content">
      <Link
        style={{
          padding: '0 5px',
          fontSize: '12px',
          color: 'var(--superapp-primary-1)',
          letterSpacing: '0.4px',
          lineHeight: '20px',
        }}
        onClick={() => changeRouter(record, spaceId)}
      >
        <span className="superapp_iconfont superapp_icon-yanjing" />
        {$i18n.get({ id: 'aopf.pages.miniapp.table.Action.Detail', dm: '详情' })}
      </Link>
    </div>
  );
};

const renderTitle = (_v, _i, record, spaceId) => {
  const { description = {} } = record;
  return (
    <div style={{ display: 'flex' }}>
      {description.iconPublicUrl ? (
        <img src={description.iconPublicUrl} className="common-table-app-icon" alt="" />
      ) : (
        <DefaultAppIcon className="common-table-app-icon" />
      )}
      <a
        className="common-table-app-name"
        onClick={() => history?.push(`/miniapp/detail?spaceId=${spaceId || ''}&appId=${record.appId}`)}
      >
        {description.name}
      </a>
    </div>
  );
};

const renderId = (value) => {
  return <div className="common-table-app-id">{value}</div>;
};

const renderStatus = (value, index, record) => {
  const status = getAppVersionStatus(record.latestPublishVersion?.versionStatus);

  return record.latestPublishVersion?.versionStatus ? (
    <ColorTags tagTheme={status?.tagTheme} name={status?.name} />
  ) : null;
};

const renderCreator = (value, _index, record) => {
  return (
    <>
      {value}
      <br />
      <span className="creator-email">{record.description.customerEmail}</span>
    </>
  );
};

const MiniappTable: React.FC<TableProps> = (props) => {
  const { dataSource = [], style = {}, loading, initFlag, setCreateTitle, spaceId } = props;
  const [visible, setVisible] = useState(false);
  const [spaceRoleState] = store.useModel('spaceRole');

  return (
    <div className="miniapp-list-table">
      <Table
        style={style}
        dataSource={dataSource}
        loading={loading}
        emptyContent={
          initFlag ? null : (
            <>
              {spaceRoleState.roleList?.includes('ADMIN')
                ? $i18n.get({
                    id: 'aopf.pages.miniapp.table.No.Miniapp.now.Click.to.create.one',
                    dm: '现在没有应用，点击创建一个',
                  })
                : $i18n.get({
                    id: 'aopf.pages.miniapp.table.No.Miniapp.no.miniApp',
                    dm: '现在没有应用',
                  })}
              {spaceRoleState.roleList?.includes('ADMIN') ? (
                <Link
                  style={{
                    padding: '0 5px',
                    fontSize: '12px',
                    color: 'var(--superapp-primary-1)',
                    letterSpacing: '0.4px',
                    lineHeight: '20px',
                    marginLeft: 16,
                  }}
                  onClick={() => setVisible(true)}
                >
                  {$i18n.get({
                    id: 'aopf.pages.miniapp.table.empty.Create.Miniapp',
                    dm: '创建应用',
                  })}
                </Link>
              ) : null}
            </>
          )
        }
      >
        <Table.Column
          title={$i18n.get({ id: 'aopf.pages.miniapp.table.Miniapp', dm: '应用名称' })}
          dataIndex="title"
          cell={(_v, _i, record)=> renderTitle(_v, _i, record, spaceId)}
          width={130}
        />
        <Table.Column
          title={$i18n.get({ id: 'aopf.pages.miniapp.table.ID', dm: 'ID' })}
          dataIndex="appId"
          width={150}
          cell={renderId}
        />
        <Table.Column
          title={$i18n.get({ id: 'aopf.pages.miniapp.table.Creator', dm: '创建者' })}
          dataIndex="createName"
          width={120}
          cell={renderCreator}
          // filter={filters}
        />
        <Table.Column
          title={$i18n.get({ id: 'aopf.pages.miniapp.table.Latest.Version', dm: '最新版本' })}
          dataIndex="maxVersion"
          cell={(value) => {
            return value ? `v${value}` : '';
          }}
          width={130}
        />
        <Table.Column
          title={$i18n.get({ id: 'aopf.pages.miniapp.table.Status', dm: '版本状态' })}
          // dataIndex="status"
          cell={renderStatus}
          width={190}
        />
        <Table.Column
          title={$i18n.get({ id: 'aopf.pages.miniapp.table.Latest.Modified', dm: '最近更新时间' })}
          dataIndex="gmtModified"
          cell={(value) => {
            return formatTime(value);
          }}
          width={170}
        />
        <Table.Column
          title={$i18n.get({ id: 'aopf.pages.miniapp.table.Action', dm: '操作' })}
          cell={(_v, _i, record)=>actions(_v, _i, record, spaceId)}
          width={100}
        />
      </Table>
      <CreateMiniappDrawer
        visible={visible}
        setVisible={setVisible}
        status="create"
        setCreateTitle={setCreateTitle}
      />
    </div>
  );
};

export default MiniappTable;
